import type { VaultOperation } from "./bound-contract";

/** Historical call projection is accepted only when it describes the signed operation exactly. */
export function validateVaultOperationCall(params: {
  readonly vaultOperation?: VaultOperation;
  readonly adapterId: string;
  readonly calls: readonly {
    readonly kind: string;
    readonly assetId: string;
    readonly amountRaw: string;
    readonly minOutRaw?: string;
    readonly yieldSourceId?: string;
    readonly spender?: string;
    readonly tokenOut?: string;
    readonly issuerArgs?: Readonly<Record<string, unknown>>;
  }[];
}): string | undefined {
  const operation = params.vaultOperation;
  if (!operation)
    return params.adapterId === "erc4626-v1"
      ? "ERC-4626 execution requires a pinned vault operation"
      : undefined;
  const call = params.calls[0];
  if (
    params.adapterId !== operation.binding.adapter ||
    params.calls.length !== 1 ||
    !call ||
    call.kind !== (operation.kind === "deposit" ? "deposit" : "withdraw") ||
    call.assetId !==
      (operation.kind === "deposit"
        ? operation.binding.underlyingAssetId
        : operation.binding.receiptAssetId) ||
    call.amountRaw !== operation.amountRaw ||
    call.minOutRaw !== operation.minOutputRaw ||
    call.yieldSourceId !== operation.binding.registryId ||
    call.spender !== undefined ||
    call.tokenOut !== undefined ||
    call.issuerArgs !== undefined
  )
    return "Vault call must match the complete pinned operation";
  return undefined;
}
